import React from 'react';
import { PPTDemoMode, type IBatchTemplateData } from '@meitu/saas-editor-core/es/version-types';
import NavigationCollapseComp from '@meitu/saas-editor-ui/es/collapses/navigation';
import { checkTypeIsAiPPT } from '@meitu/saas-editor-ui/es/utils/stage';
import { events } from '@/events-bus';
import { packageTemplateConf } from '@/hooks/fetch-template';
// import { checkIsCover, useInitPPT } from '@/hooks/fetch-template/init-ppt';
import { getStagePoints, replaceComponentKit } from '@/hooks/fetch-template/ppt-template/replace-ppt-component';
import { transferTemplateToClient } from '@/hooks/fetch-template/server-to-client';
import { editor } from '@/instance';
// import {
//     fetchAIPPTComponentList,
//     fetchPPTApplyItem,
//     fetchPPTCheckItemProcess,
//     fetchPPTItemDetail,
// } from '@/services/ppt';
import { useStoreActions, useStoreState } from '@/store';
import { checkImageEditor, isFromHuaweiCustom } from '@/utils/common';
import { getCurrentScene } from '@/utils/track';
import { transferIdParams } from '@/utils/transfer-id';

const NavigationCollapse = () => {
    const setCurrentType = useStoreActions((actions) => actions.collapseModel.setCurrentType);
    const currentType = useStoreState((state) => state.collapseModel.currentType);
    const canvasType = useStoreState((state) => state.templateModel.canvasType);
    const posterType = useStoreState((state) => state.recordModel.posterType);
    const batchTemplateData = useStoreState((state) => state.editorModel.batchTemplateData);
    const setBatchTemplateData = useStoreActions((state) => state.editorModel.setBatchTemplateData);
    const closeAiPPTPrompt = useStoreActions((actions) => actions.navigationCollapseModel.closeAiPPTPrompt);
    const stageExtraInfo = useStoreState((state) => state.templateModel.extraInfo);
    const isFullscreen = useStoreState((state) => state.editorModel.isFullscreen);
    const subject = useStoreState((state) => state.templateModel.subject);
    const isAiRegen = useStoreState((state) => state.navigationCollapseModel.isAiRegen);
    const regenIndex = useStoreState((state) => state.navigationCollapseModel.regenIndex);
    const recordId = useStoreState((state) => state.recordModel.recordInfo.id);

    const isAiPPT = checkTypeIsAiPPT(posterType);
    const showCreateTip = useStoreActions((actions) => actions.pptCreateTipModel.show);
    const hideCreateTip = useStoreActions((actions) => actions.pptCreateTipModel.hide);

    // @TODO 等 pptMode 出来后替换
    const pptMode = 'SPEAKER' as PPTDemoMode;

    const isImageEditor = checkImageEditor();
    // const initPPTHelper = useInitPPT();
    // const initPPT = initPPTHelper.adapter;

    const { setIsAiCreate, setAiRegen } = useStoreActions((actions) => actions.navigationCollapseModel);
    const { isAiCreate } = useStoreState((state) => state.navigationCollapseModel);

    const filterEmptyData = (batchTemplateData: IBatchTemplateData) => {
        let filterData: IBatchTemplateData | null = null;
        const includeColumn = batchTemplateData.headerData.filter((data) => data.labelType);
        const includeRow = batchTemplateData.contentData
            .filter((data) => {
                return data.find((item) => !!item);
            })
            .map((data, index) => {
                return data.filter((item, subIndex) => batchTemplateData.headerData[subIndex]?.labelType);
            });

        filterData = {
            headerData: includeColumn,
            contentData: includeRow,
        };

        return filterData;
    };

    return (
        <NavigationCollapseComp
            editor={editor}
            events={events}
            setCurrentType={setCurrentType}
            currentType={currentType}
            pptMode={pptMode}
            recordId={`${recordId || ''}`}
            setIsAiCreate={setIsAiCreate}
            setAiRegen={setAiRegen}
            isAiPPT={isAiPPT}
            isAiCreate={isAiCreate}
            initPPT={() => {}}
            canvasType={canvasType}
            posterType={posterType}
            batchTemplateData={batchTemplateData}
            setBatchTemplateData={setBatchTemplateData}
            filterEmptyData={filterEmptyData}
            checkIsCover={() => false}
            closeAiPPTPrompt={closeAiPPTPrompt}
            stageExtraInfo={stageExtraInfo}
            getCurrentScene={getCurrentScene}
            isFromHuaweiCustom={isFromHuaweiCustom}
            isImageEditor={isImageEditor}
            transferIdParams={transferIdParams}
            isFullscreen={isFullscreen}
            templateSubject={subject}
            showCreateTip={showCreateTip}
            hideCreateTip={hideCreateTip}
            transferTemplateToClient={transferTemplateToClient}
            packageTemplateConf={packageTemplateConf}
            fetchPPTApplyItem={() => Promise.resolve()}
            fetchPPTCheckItemProcess={() => Promise.resolve()}
            fetchPPTItemDetail={() => Promise.resolve()}
            isAiRegen={isAiRegen}
            regenIndex={regenIndex}
            fetchAIPPTComponentList={() => Promise.resolve()}
            getStagePoints={getStagePoints}
            replaceComponentKit={replaceComponentKit}
        />
    );
};

export default React.memo(NavigationCollapse);
